/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum TimePeriod {
    CurrentMonth,
    PreviousMonth,
    Last30Days,
}
